import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import useStyle from "../../hooks/useStyle";
import { useCurrentUserHook } from "../Authentication/useUserHook";

const FilterSlider = ({ component1: Component1, component2: Component2, component3: Component3, component4: Component4, allowExpand = false, ...props}) => {
  useStyle("filter_dialog");

  const { screen } = useCurrentUserHook();
  const sideNavEl = useRef(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (props.openSideNav) {
      document.addEventListener("click", handleClick, true);
    }
    return () => {
      document.removeEventListener("click", handleClick, true);
    }
  }, [props.openSideNav])

  const handleClick = (e) => {
    if (sideNavEl.current && !sideNavEl.current.contains(e.target)) {
      props.setOpenSideNav(false);
    }
  };

  const toggleExpand = () => setExpanded((s) => !s);

  const expandWidth = expanded
    ? screen.xs ? "90%" : "50%"
    : screen.xs ? 260 : 320;

  return ReactDOM.createPortal(
    <div
      id="menu-main"
      ref={sideNavEl}
      className={`menu filter-box-right menu-box-detached ani-opc-2 ${props.openSideNav ? "menu-active" : "hidden"}`}
      style={{ width: expandWidth, transition: "width 0.25s ease", zIndex: 400 }}>

      {allowExpand &&
        <button
          type="button"
          onClick={toggleExpand}
          aria-label={expanded ? "Collapse" : "Expand"}
          className="filter-expand-btn">
          <i className={`fas ${expanded ? "fa-arrow-right" : "fa-arrow-left"} font-22`} aria-hidden="true"/>
        </button>
      }

      <div className="bg-highlight-2">
        <h5 className="white text-left p-10">
          {props.title ? props.title : "Filters"}
        </h5>
      </div>

      {Component1 && <Component1 {...props} />}
      {Component2 && <Component2 {...props} />}
      {Component3 && <Component3 {...props} />}
      {Component4 && <Component4 {...props} />}

    </div>,
    document.body
  );
};

export default FilterSlider;